import { SetConnectionStatusAction, SetOfflineModeSimulationAction } from './actions';
import { ConnectionStatusState } from './state';
import update from 'immutability-helper';
import { createSwitch, createCase } from 'helpers/action-helpers';

const initialState: ConnectionStatusState = {
  isSimulatingOfflineMode: false
};

export const connectionStatusReducer = createSwitch(initialState, [
  createCase(new SetConnectionStatusAction(false), (state, action) => {
    return update(state, {
      isConnected: { $set: action.isConnected }
    });
  }),
  createCase(new SetOfflineModeSimulationAction(false), (state, action) => {
    return update(state, {
      isSimulatingOfflineMode: { $set: action.shouldSimulate }
    });
  })
]);


// WEBPACK FOOTER //
// ./src/components/connection-status/reducer.ts